import { push } from 'connected-react-router';

import { home } from 'src/app/router/paths';
import { useDispatch } from 'src/app/state/store';

import { Success } from '../../Elements/Success';

export const UpdatePhoneSuccessPage = () => {
  const dispatch = useDispatch();
  return (
    <Success
      title={'Success'}
      body={'Your phone number has been updated.'}
      cta={{ onClick: () => dispatch(push(home.toPath())), text: 'Continue' }}
    />
  );
};
